






import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { StompClient } from "@/service/StompClient";

@Component

export default class Main extends Vue {
  @Action("disconnect", { namespace: "Socket" })
  disconnectSocket: any;
  @Getter("socket", { namespace: "Socket" })
  socket: StompClient;

  destroyed(){
    //SocketIO解放
    this.disconnectSocket();
  }
}
